import React from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../../../components/Common/CustomModal";
import { formatToFrenchDate } from "../../../../utils/dateUtils";
import { Descriptions, Tag, Typography } from "antd";
import { getSubjectLabelFromCode } from "utils/schoolUtils";

interface TaskDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTask: { topic: string; subject: string; description: string; dueDate: string , subjectCode: string } | null;
  loading: boolean;
}

const TaskDetailsModal: React.FC<TaskDetailsModalProps> = ({ isOpen, onClose, selectedTask, loading }) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      title={t("details")}
      isOpen={isOpen}
      onClose={onClose}
      loading={loading}
      width="600px"
      style={{ borderRadius: 12 }}
    >
      {selectedTask ? (
        <div style={{ background: '#f7f3ff', borderRadius: 8, padding: 24 }}>
          <Descriptions
            bordered
            column={1}
            size="middle"
            labelStyle={{ color: '#563a9d', fontWeight: 600 }}
            contentStyle={{ background: '#ffffff', padding: 12 }}
          >
            <Descriptions.Item label={t('title')}>
              <Typography.Text strong>{selectedTask.topic}</Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label={t('subject')}>
              <Tag color="#563a9d" style={{ fontWeight: 500 }}>{getSubjectLabelFromCode(selectedTask?.subjectCode || "")}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label={t('description')}>
              <Typography.Text>{selectedTask.description}</Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label={t('due_date')}>
              <Tag color="#fa541c">{formatToFrenchDate(selectedTask.dueDate)}</Tag>
            </Descriptions.Item>
          </Descriptions>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Typography.Text type="secondary">{t('no_task_selected')}</Typography.Text>
        </div>
      )}
    </CustomModal>
  );
};

export default TaskDetailsModal;
